// extracted by mini-css-extract-plugin
export default {"customcursor":"cursor_customcursor__K4rx+","change":"cursor_change__-mMeW"};